<template>
  <div class="pending-income-confirmation">
    <el-form ref="searchForm" :inline="true" :model="searchForm" class="searchBoxLine">
      <el-form-item label="合同编号" prop="customerPoCode">
        <el-input class="customer-po-code-input" :value="searchForm.customerPoCode" placeholder="多个编号请用英文逗号分隔" clearable style="width: 230px;" @input="handleCustomerPoCodeInput" @paste.native="handleCustomerPoCodePaste" @blur="handleCustomerPoCodeBlur" />
      </el-form-item>
      <el-form-item label="发货单号" prop="deliveryNo">
        <el-input v-model.trim="searchForm.deliveryNo" placeholder="请输入发货单号" clearable />
      </el-form-item>
      <el-form-item label="客户名称" prop="customerName">
        <el-input v-model.trim="searchForm.customerName" placeholder="请输入客户名称" clearable />
      </el-form-item>
      <el-form-item label="销售项目名称" prop="projectName">
        <el-input v-model.trim="searchForm.projectName" placeholder="请输入销售项目名称" clearable />
      </el-form-item>
      <el-form-item label="发货日期">
        <div class="delivery-date-fields">
          <el-date-picker v-model="searchForm.deliveryDateStart" type="date" placeholder="开始日期" value-format="yyyy-MM-dd" format="yyyy-MM-dd" clearable />
          <span class="delivery-date-separator">至</span>
          <el-date-picker v-model="searchForm.deliveryDateEnd" type="date" placeholder="结束日期" value-format="yyyy-MM-dd" format="yyyy-MM-dd" clearable />
        </div>
      </el-form-item>
      <el-form-item label="确收规则" prop="acceptanceRule">
        <el-select v-model="searchForm.acceptanceRule" placeholder="请选择确收规则" :clearable="searchForm.acceptanceRule !== '全部'" @clear="handleFilterClear('acceptanceRule')">
          <el-option label="全部" value="全部" />
          <el-option label="到货验收" value="到货验收" />
          <el-option label="初验" value="初验" />
          <el-option label="终验" value="终验" />
        </el-select>
      </el-form-item>
      <!-- <el-form-item label="客户签约类型" prop="customerSignType">
        <el-select v-model="searchForm.customerSignType" placeholder="请选择客户签约类型" :clearable="searchForm.customerSignType !== '全部'" @clear="handleFilterClear('customerSignType')">
          <el-option label="全部" value="全部" />
          <el-option label="直签" value="直签" />
          <el-option label="代理商" value="代理商" />
        </el-select>
      </el-form-item> -->
      <el-form-item label="部门" prop="department">
        <el-input v-model.trim="searchForm.department" placeholder="请输入部门" clearable />
        <el-button type="primary" :loading="isLoading" style="margin-left: 12px;" @click="doSearch">搜索</el-button>
        <el-button @click="resetForm">重置</el-button>
      </el-form-item>
    </el-form>

    <div class="top-action-bar">
      <el-button type="primary" @click="openSelectedAcceptanceDialog">提交验收</el-button>
    </div>

    <div v-loading="isLoading">
      <div v-for="order in tableData" :key="order.id" class="order-card">
        <div class="order-main">
          <div class="order-info">
            <div class="order-title">
              <el-checkbox class="order-select-all" :value="isOrderAllSelected(order)" :indeterminate="isOrderIndeterminate(order)" @change="(checked) => toggleOrderSelection(order, checked)" />
              <span>{{ order.orderCode }}</span>
            </div>
            <div class="order-meta">
              实际结算金额：{{ formatAmount(order.orderAmount) }}
            </div>
          </div>
          <div class="order-actions">
            <el-button size="mini" @click="toggleDetail(order)">{{ order.expanded ? '收起订单明细' : '展开订单明细' }}</el-button>
            <el-button type="primary" size="mini" @click="prepareWholeAcceptance(order)">整单验收</el-button>
          </div>
          <div class="order-stat-list">
            <div class="order-stat">
              <div class="stat-label">客户名称</div>
              <div class="stat-value">{{ order.customerTag || '-' }}</div>
            </div>
            <div class="order-stat">
              <div class="stat-label">销售项目名称</div>
              <div class="stat-value">{{ order.projectName || '-' }}</div>
            </div>
            <!-- <div class="order-stat">
              <div class="stat-label">客户采购单号</div>
              <div class="stat-value">{{ order.customerPoCode || '-' }}</div>
            </div> -->
            <div class="order-stat two">
              <div class="stat-label">已选金额</div>
              <div class="stat-value">{{ formatAmount(getSelectedAmount(order)) }}</div>
            </div>
            <div class="order-stat two">
              <div class="stat-label">可验收数量</div>
              <div class="stat-value">{{ getConfirmableQuantity(order) }}</div>
            </div>
            <div class="order-stat two">
              <div class="stat-label">本次验收数量</div>
              <div class="stat-value">{{ getCurrentConfirmQuantity(order) }}</div>
            </div>
          </div>
        </div>

        <div v-for="deliveryInfo in order.deliveryInfos" v-show="order.expanded" :key="deliveryInfo.id" class="delivery-section">
          <div class="delivery-info">
            <div class="delivery-info-check">
              <el-checkbox :value="isDeliveryAllSelected(order, deliveryInfo)" :indeterminate="isDeliveryIndeterminate(order, deliveryInfo)" @change="(checked) => toggleDeliverySelection(order, deliveryInfo, checked)" />
            </div>
            <div class="delivery-info-fields">
              <div class="delivery-info-item delivery-info-item--number">
                <span class="delivery-info-label">发货单号</span>
                <span class="delivery-info-value">{{ deliveryInfo.deliveryNo || '-' }}</span>
              </div>
              <div class="delivery-info-item">
                <span class="delivery-info-label">发货日期</span>
                <span class="delivery-info-value">{{ deliveryInfo.deliveryDate || '-' }}</span>
              </div>
              <div class="delivery-info-item">
                <span class="delivery-info-label">签收日期</span>
                <span class="delivery-info-value">{{ deliveryInfo.confirmDate || '-' }}</span>
              </div>
              <div class="delivery-info-item delivery-info-item--address">
                <span class="delivery-info-label">收货地址</span>
                <span class="delivery-info-value">{{ deliveryInfo.deliveryAddress || '-' }}</span>
              </div>
            </div>
            <div class="delivery-actions">
              <el-button size="mini" @click="toggleDeliveryDetail(deliveryInfo)">{{ deliveryInfo.expanded ? '收起发货明细' : '展开发货明细' }}</el-button>
            </div>
          </div>

          <el-table v-show="deliveryInfo.expanded" :ref="`lineTable-${order.id}-${deliveryInfo.id}`" :data="deliveryInfo.orderLines" border class="line-table" :row-key="getRowKey" @selection-change="(selection) => handleSelectionChange(order, deliveryInfo, selection)">
            <el-table-column type="selection" label="勾选" width="50" align="center" />
            <el-table-column prop="erpOrderNo" label="ERP订单号" width="110" align="left" />
            <el-table-column prop="orderLineNum" label="订单行" width="80" align="left" />
            <el-table-column label="订单类型" width="140" align="left">
              <template v-slot="{ row }">
                {{ row.orderType || '-' }}
              </template>
            </el-table-column>
            <el-table-column label="确收规则" width="90" align="left">
              <template v-slot="{ row }">
                <span class="line-rule">{{ getAcceptanceRule(row) }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="materialNum" label="物料编码" width="150" align="left" />
            <el-table-column prop="lineContent" label="物料描述" min-width="300" align="left" />
            <el-table-column label="实际结算金额" width="110" align="right" header-align="left">
              <template v-slot="{ row }">{{ formatAmount(row.orderAmount) }}</template>
            </el-table-column>
            <el-table-column label="可验收金额" width="110" align="right" header-align="left">
              <template v-slot="{ row }">{{ formatAmount(row.confirmableAmount) }}</template>
            </el-table-column>
            <el-table-column prop="confirmableQuantity" label="可验收数量" width="90" align="center" />
            <el-table-column label="本次验收数量" width="150" align="center">
              <template v-slot="{ row }">
                <el-input-number v-model="row.currentConfirmQuantity" :min="0" :max="row.confirmableQuantity" :controls="false" size="mini" @change="handleQuantityChange(row)" />
              </template>
            </el-table-column>
            <el-table-column label="本次验收金额" width="120" align="right" header-align="left">
              <template v-slot="{ row }">{{ formatAmount(row.currentConfirmAmount) }}</template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <el-empty v-if="!isLoading && tableData.length === 0" description="暂无数据" class="empty-list" />
    </div>

    <div class="pagination-wrap">
      <el-pagination
        :page-sizes="[10, 20, 30, 40]"
        :page-size.sync="page.pageSize"
        :current-page.sync="page.currentPage"
        layout="total, prev, pager, next, jumper,sizes"
        :total="page.total"
        hide-on-single-page
        @size-change="handerSizeChange"
        @current-change="handerCurrentChange"
      />
    </div>

    <el-dialog title="提交验收" :visible.sync="submitAcceptanceVisible" width="90vw" class="acceptance-dialog" :close-on-click-modal="false" :close-on-press-escape="false" :before-close="handleSubmitAcceptanceDialogClose" @close="clearSubmitAcceptanceData">
      <el-form class="submit-acceptance-form" label-width="120px">
        <el-form-item label="验收日期" required>
          <el-date-picker v-model="wholeAcceptanceForm.acceptanceTime" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd" placeholder="请选择验收日期" @change="handleAcceptanceTimeChange" />
        </el-form-item>
        <el-form-item label="确认日期">
          <span class="readonly-date">{{ submitConfirmDate }}</span>
        </el-form-item>
        <el-form-item label="系统接收日期" required>
          <el-date-picker v-model="wholeAcceptanceForm.systemReceiveDate" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd" placeholder="请选择验收日期" />
        </el-form-item>
        <el-form-item label="验收资料" class="submit-acceptance-form__attachments">
          <el-upload action="#" :auto-upload="false" :show-file-list="false" :multiple="true" :on-change="handleAcceptanceFileChange">
            <el-button type="primary" plain icon="el-icon-upload2">上传附件</el-button>
          </el-upload>
          <el-table v-if="acceptanceFileList.length" :data="acceptanceFileList" border size="mini" class="attachment-table">
            <el-table-column label="附件名称" min-width="220" align="left">
              <template v-slot="{ row }">
                <span v-if="row.uploading"><i class="el-icon-loading" /> {{ row.name }} (上传中...)</span>
                <span v-else class="attachment-name" @click="handleAttachmentClick(row)">{{ row.name }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="uploader" label="上传人" width="140" align="left" />
            <el-table-column prop="uploadTime" label="上传时间" width="170" align="left" />
            <el-table-column label="操作" width="80" align="center">
              <template v-slot="{ $index }">
                <el-button type="text" icon="el-icon-delete" class="attachment-delete" :disabled="submitLoading" @click="handleRemoveAttachment($index)" />
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
      </el-form>
      <div class="dialog-tip">
        已选择 {{ acceptanceLines.length }} 条订单行，请确认后提交验收。
      </div>
      <el-table :data="acceptanceLines" border class="submit-table" max-height="420">
        <!-- <el-table-column prop="customerPoCode" label="客户采购单编号" width="150" align="left" /> -->
        <el-table-column prop="cesContractNo" label="合同编号" width="160" align="left" />
        <el-table-column prop="deliveryNo" label="发货单号" width="150" align="left" />
        <el-table-column prop="erpOrderNo" label="ERP订单号" width="160" align="left" />
        <el-table-column prop="deliveryDate" label="发货日期" width="120" align="left" />
        <el-table-column prop="confirmDate" label="签收日期" width="120" align="left" />
        <el-table-column prop="orderLineNum" label="订单行" width="100" align="left" />
        <el-table-column prop="orderType" label="订单类型" width="120" align="left" />
        <el-table-column label="确收规则" width="120" align="left">
          <template v-slot="{ row }">
            <span class="line-rule">{{ getAcceptanceRule(row) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="materialNum" label="物料编码" width="140" align="left" />
        <el-table-column prop="lineContent" label="物料描述" min-width="240" align="left" />
        <el-table-column prop="confirmableQuantity" label="可验收数量" width="110" align="center" />
        <el-table-column prop="currentConfirmQuantity" label="本次验收数量" width="120" align="center" />
        <el-table-column label="本次验收金额" width="130" align="right" header-align="left">
          <template v-slot="{ row }">{{ formatAmount(row.currentConfirmAmount) }}</template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button :disabled="submitLoading" @click="submitAcceptanceVisible = false">取消</el-button>
        <el-button type="primary" :loading="submitLoading" :disabled="submitLoading" @click="confirmSubmitAcceptance">确认提交</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getAcceptanceReceiptList, submitAcceptance, attachmentGetToken } from '@/API';
import AxiosApi from '@/API/fileAxios';
import { Empty, MessageBox } from 'element-ui';
import dayjs from 'dayjs';

export default {
  components: {
    ElEmpty: Empty
  },
  data () {
    return {
      isLoading: false,
      searchForm: {
        customerPoCode: '',
        deliveryNo: '',
        customerName: '',
        projectName: '',
        deliveryDateStart: dayjs().subtract(3, 'month').format('YYYY-MM-DD'),
        deliveryDateEnd: '',
        acceptanceRule: '全部',
        customerSignType: '全部',
        department: ''
      },
      orderTypeOptions: [
        { label: '执行订单', value: '执行订单' },
        { label: '换货订单', value: '换货订单' }
      ],
      tableData: [],
      selectedLineMap: {},
      wholeAcceptanceLines: [],
      submitAcceptanceVisible: false,
      submitLoading: false,
      wholeAcceptanceForm: {
        acceptanceTime: '',
        systemReceiveDate: '',
        attachmentName: ''
      },
      acceptanceFileList: [],
      fileUploadToken: null,
      page: {
        pageSize: 10,
        total: 0,
        currentPage: 1
      }
    };
  },
  computed: {
    orderLineTotal () {
      return this.tableData.reduce((total, order) => total + order.orderLines.length, 0);
    },
    submitConfirmDate () {
      return this.getCurrentDate();
    },
    selectedLines () {
      return Object.keys(this.selectedLineMap).reduce((list, orderId) => {
        return list.concat(this.selectedLineMap[orderId] || []);
      }, []);
    },
    acceptanceLines () {
      return this.wholeAcceptanceLines.length ? this.wholeAcceptanceLines : this.selectedLines;
    }
  },
  mounted () {
    this.doSearch();
  },
  methods: {
    normalizeCustomerPoCodes (value) {
      const normalizedSource = String(value || '')
        .replace(/[\r\n\t，]/g, ',')
        .replace(/[^a-zA-Z0-9,]/g, '');
      const codes = normalizedSource
        .split(',')
        .map((code) => code.trim())
        .filter(Boolean);
      const distinctCodes = codes.filter((code, index) => codes.indexOf(code) === index);
      return distinctCodes.slice(0, 10).join(',');
    },
    handleCustomerPoCodeInput (value) {
      const normalizedValue = this.normalizeCustomerPoCodes(value);
      const inputEndsWithComma = String(value || '').replace(/[\r\n\t，]/g, ',').endsWith(',');
      const codeCount = normalizedValue ? normalizedValue.split(',').length : 0;
      const displayValue = inputEndsWithComma && codeCount > 0 && codeCount < 10 ? `${normalizedValue},` : normalizedValue;
      this.searchForm.customerPoCode = displayValue;
    },
    handleCustomerPoCodeBlur () {
      this.searchForm.customerPoCode = this.normalizeCustomerPoCodes(this.searchForm.customerPoCode);
    },
    handleCustomerPoCodePaste (event) {
      const pastedValue = event.clipboardData ? event.clipboardData.getData('text') : '';
      if (!pastedValue) {
        return;
      }
      event.preventDefault();
      const input = event.target;
      const currentValue = this.searchForm.customerPoCode || '';
      const start = input.selectionStart || 0;
      const end = input.selectionEnd || start;
      const valueBeforePaste = currentValue.slice(0, start);
      const valueAfterPaste = currentValue.slice(end);
      const separator = valueBeforePaste && pastedValue ? ',' : '';
      this.searchForm.customerPoCode = this.normalizeCustomerPoCodes(`${valueBeforePaste}${separator}${pastedValue}${valueAfterPaste}`);
    },
    validateCustomerPoCode () {
      const customerPoCode = this.normalizeCustomerPoCodes(this.searchForm.customerPoCode);
      this.searchForm.customerPoCode = customerPoCode;
      if (!customerPoCode) {
        return true;
      }
      const codes = customerPoCode.split(',');
      return codes.length <= 10 && codes.every((code) => /^[a-zA-Z0-9]+$/.test(code));
    },
    doSearch () {
      if (!this.validateCustomerPoCode()) {
        this.$message.warning('合同编号格式不正确，请输入最多10个由字母或数字组成的编号，并用英文逗号分隔');
        return;
      }
      const { deliveryDateStart, deliveryDateEnd } = this.searchForm;
      // if (!deliveryDateStart && !deliveryDateEnd) {
      //   this.$message.warning('请选择发货日期');
      //   return;
      // }
      this.isLoading = true;
      getAcceptanceReceiptList({
        customerPoCode: this.searchForm.customerPoCode,
        deliveryNo: this.searchForm.deliveryNo,
        customerName: this.searchForm.customerName,
        projectName: this.searchForm.projectName,
        deliveryDateStart,
        deliveryDateEnd,
        acceptanceRule: this.searchForm.acceptanceRule,
        customerContractType: this.searchForm.customerSignType,
        departmentName: this.searchForm.department,
        pageIndex: this.page.currentPage,
        pageSize: this.page.pageSize
      }).then((res) => {
        this.isLoading = false;
        const json = res.data;
        if (json.status === '200') {
          this.tableData = this.formatTableData(json.data.list);
          this.page.total = json.data.totalCount;
          this.selectedLineMap = {};
        } else {
          this.tableData = [];
          this.page.total = 0;
        }
      }).catch(() => {
        this.isLoading = false;
      });
    },
    resetForm () {
      this.$refs.searchForm.resetFields();
      this.page.currentPage = 1;
      this.doSearch();
    },
    handleFilterClear (field) {
      this.searchForm[field] = '全部';
    },
    handerSizeChange () {
      this.page.currentPage = 1;
      this.doSearch();
    },
    handerCurrentChange (val) {
      this.page.currentPage = val;
      this.doSearch();
    },
    collapseExpandedDetails () {
      this.tableData.forEach((order) => {
        this.$set(order, 'expanded', false);
        order.deliveryInfos.forEach((deliveryInfo) => {
          this.$set(deliveryInfo, 'expanded', false);
        });
      });
    },
    toggleDetail (order) {
      this.$set(order, 'expanded', !order.expanded);
    },
    toggleDeliveryDetail (deliveryInfo) {
      this.$set(deliveryInfo, 'expanded', !deliveryInfo.expanded);
    },
    handleSelectionChange (order, deliveryInfo, selection) {
      const previousSelection = this.selectedLineMap[order.id] || [];
      const previousSelectionMap = previousSelection.reduce((map, line) => {
        map[line.lineId] = true;
        return map;
      }, {});
      const currentSelectionMap = selection.reduce((map, line) => {
        map[line.lineId] = true;
        return map;
      }, {});

      deliveryInfo.orderLines.forEach((line) => {
        const wasSelected = !!previousSelectionMap[line.lineId];
        const isSelected = !!currentSelectionMap[line.lineId];

        if (!wasSelected && isSelected) {
          line.currentConfirmQuantity = Number(line.confirmableQuantity) || 0;
          this.handleQuantityChange(line);
        }

        if (wasSelected && !isSelected) {
          line.currentConfirmQuantity = 0;
          this.handleQuantityChange(line);
        }
      });

      const deliveryLineMap = deliveryInfo.orderLines.reduce((map, line) => {
        map[line.lineId] = true;
        return map;
      }, {});
      this.$set(this.selectedLineMap, order.id, previousSelection.filter((line) => !deliveryLineMap[line.lineId]).concat(selection));
    },
    isOrderAllSelected (order) {
      const selection = this.selectedLineMap[order.id] || [];
      return order.orderLines.length > 0 && selection.length === order.orderLines.length;
    },
    isOrderIndeterminate (order) {
      const selection = this.selectedLineMap[order.id] || [];
      return selection.length > 0 && selection.length < order.orderLines.length;
    },
    isDeliveryAllSelected (order, deliveryInfo) {
      const selectedLineMap = (this.selectedLineMap[order.id] || []).reduce((map, line) => {
        map[line.lineId] = true;
        return map;
      }, {});
      return deliveryInfo.orderLines.length > 0 && deliveryInfo.orderLines.every((line) => selectedLineMap[line.lineId]);
    },
    isDeliveryIndeterminate (order, deliveryInfo) {
      const selectedLineMap = (this.selectedLineMap[order.id] || []).reduce((map, line) => {
        map[line.lineId] = true;
        return map;
      }, {});
      const selectedCount = deliveryInfo.orderLines.filter((line) => selectedLineMap[line.lineId]).length;
      return selectedCount > 0 && selectedCount < deliveryInfo.orderLines.length;
    },
    getLineTable (order, deliveryInfo) {
      const tableRef = this.$refs[`lineTable-${order.id}-${deliveryInfo.id}`];
      return Array.isArray(tableRef) ? tableRef[0] : tableRef;
    },
    toggleDeliverySelection (order, deliveryInfo, checked) {
      this.$nextTick(() => {
        const table = this.getLineTable(order, deliveryInfo);
        if (!table) {
          return;
        }
        if (checked) {
          deliveryInfo.orderLines.forEach((line) => {
            table.toggleRowSelection(line, true);
          });
        } else {
          table.clearSelection();
        }
      });
    },
    toggleOrderSelection (order, checked) {
      order.deliveryInfos.forEach((deliveryInfo) => {
        this.toggleDeliverySelection(order, deliveryInfo, checked);
      });
    },
    handleAcceptanceTimeChange (value) {
      this.wholeAcceptanceForm.systemReceiveDate = value;
    },

    formatTableData (list) {
      const orderMap = {};
      (list || []).forEach((sourceLine, lineIndex) => {
        const orderCode = sourceLine.contractNum || sourceLine.customerPurchaseOrderNo || `order-${lineIndex}`;
        if (!orderMap[orderCode]) {
          orderMap[orderCode] = {
            id: orderCode,
            orderCode,
            customerTag: sourceLine.accountName || '',
            customerPoCode: sourceLine.customerPurchaseOrderNo || '',
            projectName: sourceLine.projectName || '',
            orderAmount: 0,
            expanded: false,
            orderLines: [],
            deliveryInfos: [],
            deliveryMap: {}
          };
        }
        const order = orderMap[orderCode];
        const deliveryNo = sourceLine.requestHeaderNumber || '';
        const deliveryDate = sourceLine.deliveryDate || sourceLine.rmaDeliveryDate || '';
        const confirmDate = String(sourceLine.customerReceiptDate || '').split(/[ T]/)[0];
        const deliveryKey = deliveryNo || `delivery-${lineIndex}`;
        if (!order.deliveryMap[deliveryKey]) {
          order.deliveryMap[deliveryKey] = {
            id: deliveryKey,
            deliveryNo,
            deliveryDate,
            confirmDate,
            deliveryAddress: sourceLine.shipToAddress1 || '',
            expanded: false,
            orderLines: []
          };
          order.deliveryInfos.push(order.deliveryMap[deliveryKey]);
        }
        order.orderAmount += Number(sourceLine.enteredAmt) || 0;
        const line = {
          ...sourceLine,
          lineId: sourceLine.clearId || `${orderCode}-${sourceLine.erpOrderNo || ''}-${sourceLine.orderLineNum || ''}-${sourceLine.requestLineNumber || lineIndex}`,
          orderId: order.id,
          orderCode,
          customerPoCode: order.customerPoCode,
          customerName: sourceLine.accountName || '',
          customerContractType: sourceLine.customerContractType || '',
          departmentName: sourceLine.departmentName || '',
          cesContractNo: sourceLine.contractNum || '',
          projectName: sourceLine.projectName || order.projectName,
          lineContent: sourceLine.materialDescription || sourceLine.productDescription || sourceLine.lineContent || '',
          materialNum: sourceLine.materialNumber || sourceLine.materialNum || '',
          deliveryNo,
          deliveryDate: sourceLine.deliveryDate || sourceLine.rmaDeliveryDate || '',
          confirmDate,
          deliveryAddress: sourceLine.shipToAddress1 || '',
          orderAmount: Number(sourceLine.enteredAmt) || 0,
          confirmableAmount: Number(((Number(sourceLine.unitPrice) || 0) * (Number(sourceLine.confirmableQuantity) || 0)).toFixed(2)),
          currentConfirmQuantity: 0,
          currentConfirmAmount: 0
        };
        order.orderLines.push(line);
        order.deliveryMap[deliveryKey].orderLines.push(line);
      });
      return Object.keys(orderMap).map((key) => {
        const order = orderMap[key];
        delete order.deliveryMap;
        return order;
      });
    },
    prepareWholeAcceptance (order) {
      order.orderLines.forEach((line) => {
        line.currentConfirmQuantity = line.confirmableQuantity;
        this.handleQuantityChange(line);
      });
      this.wholeAcceptanceLines = order.orderLines;
      this.openSubmitAcceptanceDialog();
    },
    handleAcceptanceFileChange (file) {
      const item = {
        name: file.name,
        url: file.raw ? URL.createObjectURL(file.raw) : '',
        fileToken: '',
        raw: file.raw,
        uploader: this.getCurrentUserName(),
        uploadTime: this.getCurrentDateTime(),
        uploading: true
      };
      this.acceptanceFileList.push(item);
      this.uploadSingleFile(item);
    },
    /** 获取上传凭证（缓存复用） */
    async getUploadToken () {
      if (this.fileUploadToken) return this.fileUploadToken;
      const res = await attachmentGetToken();
      if (res.data.status !== '200') {
        throw new Error('获取上传凭证失败');
      }
      this.fileUploadToken = {
        token: res.data.data.token,
        uploadUrl: res.data.data.uploadUrl,
        downloadUrl: res.data.data.downloadUrl
      };
      return this.fileUploadToken;
    },
    /** 立即上传单个文件获取 fileToken */
    async uploadSingleFile (item) {
      if (!item.raw) return;
      try {
        const { token, uploadUrl, downloadUrl } = await this.getUploadToken();
        const form = new FormData();
        form.append('files', item.raw);
        const uploadRes = await AxiosApi.post(uploadUrl + '?Token=' + token, form, {
          headers: { 'Content-Type': 'multipart/form-data' }
        });
        if (uploadRes.data.status === '200' && uploadRes.data.data?.[0]) {
          const uploadedFile = uploadRes.data.data[0];
          item.fileToken = uploadedFile.FID;
          item.name = uploadedFile.FullName || item.name;
          item.url = uploadedFile.url || uploadedFile.fileUrl || `${downloadUrl}/${item.fileToken}?Token=${token}`;
          item.uploading = false;
        } else {
          item.uploading = false;
          this.$message.error(`文件"${item.name}"上传失败`);
        }
      } catch (e) {
        item.uploading = false;
        this.$message.error(`文件"${item.name}"上传失败`);
      }
    },
    /**
     * 提交验收：直接收集已上传的 fileToken，无需等待上传
     */
    doSubmitAcceptance (fileList, selectedLines, callback) {
      const attachments = fileList
        .filter((f) => f.fileToken)
        .map((f) => ({ fileToken: f.fileToken, fileName: f.name, fileUrl: f.url }));
      const params = {
        acceptanceTime: this.wholeAcceptanceForm.acceptanceTime,
        systemReceiveDate: this.wholeAcceptanceForm.systemReceiveDate,
        submitConfirmDate: this.submitConfirmDate,
        currentUserId: (window.$core?.user?.userId) || '',
        currentUserName: (window.$core?.user?.userName) || '',
        attachments: attachments,
        selectedLines: selectedLines.map((line) => ({
          clearId: line.clearId || '',
          customerPurchaseOrderNo: line.contractNum || line.cesContractNo || '',
          contractNum: line.contractNum || line.cesContractNo || '',
          customerName: line.customerName || '',
          customerContractType: line.customerContractType || '',
          departmentName: line.departmentName || '',
          erpOrderNo: line.erpOrderNo || '',
          orderType: line.orderType || '',
          deliveryNo: line.deliveryNo || '',
          deliveryDate: line.deliveryDate || '',
          orderLine: line.orderLineNum || '',
          acceptanceRule: line.acceptanceRule || '',
          productDescription: line.lineContent || '',
          projectName: line.projectName || '',
          materialNum: line.materialNum || line.materialNumber || '',
          orderAmount: line.orderAmount || 0,
          confirmableQuantity: line.confirmableQuantity || 0,
          confirmableAmount: line.confirmableAmount || 0,
          currentConfirmQuantity: line.currentConfirmQuantity || 0,
          currentConfirmAmount: line.currentConfirmAmount || 0,
          acceptanceTime: line.acceptanceTime || this.wholeAcceptanceForm.acceptanceTime,
          submitConfirmDate: this.submitConfirmDate,
          erpExecNo: line.erpExecNo || ''
        }))
      };
      return submitAcceptance(params).then((res) => {
        if (res.data.status === '200') {
          callback(res.data.data);
        } else {
          this.showMultilineResult(res.data.err || '提交验收失败', '收入确认失败', 'error');
        }
      }).catch((error) => {
        this.showMultilineResult(error.response?.data?.err || '提交验收请求失败，请稍后重试', '收入确认失败', 'error');
      });
    },
    showMultilineResult (message, title, type) {
      const escapedMessage = String(message || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;')
        .replace(/\r?\n/g, '<br>');
      MessageBox.alert(escapedMessage, title, {
        type: type,
        dangerouslyUseHTMLString: true,
        confirmButtonText: '确定'
      });
    },
    handleAttachmentClick (row) {
      if (row.url) {
        window.open(row.url);
      }
    },
    handleRemoveAttachment (index) {
      if (this.submitLoading) {
        return;
      }
      this.$confirm('确认删除该附件吗？', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const file = this.acceptanceFileList[index];
        if (file && file.url && file.url.indexOf('blob:') === 0) {
          URL.revokeObjectURL(file.url);
        }
        this.acceptanceFileList.splice(index, 1);
      }).catch(() => {});
    },
    clearSubmitAcceptanceData () {
      this.acceptanceFileList.forEach((file) => {
        if (file.url && file.url.indexOf('blob:') === 0) {
          URL.revokeObjectURL(file.url);
        }
      });
      this.acceptanceFileList = [];
      this.wholeAcceptanceLines = [];
      this.wholeAcceptanceForm.acceptanceTime = '';
      this.wholeAcceptanceForm.systemReceiveDate = '';
    },
    openSelectedAcceptanceDialog () {
      this.wholeAcceptanceLines = [];
      this.openSubmitAcceptanceDialog();
    },
    openSubmitAcceptanceDialog () {
      if (!this.acceptanceLines.length) {
        this.$message.warning('请先勾选需要提交验收的订单行');
        return false;
      }
      if (!this.wholeAcceptanceForm.acceptanceTime) {
        this.wholeAcceptanceForm.acceptanceTime = this.getCurrentDate();
      }
      if (!this.wholeAcceptanceForm.systemReceiveDate) {
        this.wholeAcceptanceForm.systemReceiveDate = this.getCurrentDate();
      }
      this.submitAcceptanceVisible = true;
    },
    async confirmSubmitAcceptance () {
      if (this.submitLoading) {
        return;
      }
      if (!this.wholeAcceptanceForm.acceptanceTime) {
        this.$message.warning('请选择验收时间');
        return false;
      }
      if (!this.wholeAcceptanceForm.systemReceiveDate) {
        this.$message.warning('请选择系统接收日期');
        return false;
      }
      const invalidLine = this.acceptanceLines.find((line) => Number(line.currentConfirmQuantity || 0) <= 0);
      if (invalidLine) {
        this.$message.warning('本次验收数量需大于0');
        return false;
      }
      if (this.acceptanceFileList.some((file) => file.uploading)) {
        this.$message.warning('附件上传中，请稍后再提交');
        return false;
      }
      MessageBox.confirm('请确认系统接收日期是否准确？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        this.submitLoading = true;
        await this.$nextTick();
        this.doSubmitAcceptance(this.acceptanceFileList, this.acceptanceLines, (resultMessage) => {
          this.submitAcceptanceVisible = false;
          if (resultMessage && resultMessage !== '提交成功') {
            this.showMultilineResult(resultMessage, '部分收入确认失败', 'warning');
          } else {
            this.$message.success('提交验收成功');
          }
          this.doSearch();
        }).finally(() => {
          this.submitLoading = false;
        });
      }).catch(() => {});
    },
    handleSubmitAcceptanceDialogClose (done) {
      if (!this.submitLoading) {
        done();
      }
    },
    handleQuantityChange (row) {
      const quantity = Number((Number(row.currentConfirmQuantity) || 0).toFixed(6));
      const unitAmount = row.confirmableQuantity ? row.confirmableAmount / row.confirmableQuantity : 0;
      this.$set(row, 'currentConfirmQuantity', Math.max(0, Math.min(quantity, row.confirmableQuantity)));
      this.$set(row, 'currentConfirmAmount', Number((unitAmount * row.currentConfirmQuantity).toFixed(2)));
    },
    getSelectedAmount (order) {
      const selection = this.selectedLineMap[order.id] || [];
      return selection.reduce((total, line) => total + Number(line.currentConfirmAmount || 0), 0);
    },
    getConfirmableQuantity (order) {
      return order.orderLines.reduce((total, line) => total + Number(line.confirmableQuantity || 0), 0);
    },
    getCurrentConfirmQuantity (order) {
      const selection = this.selectedLineMap[order.id] || [];
      return selection.reduce((total, line) => total + Number(line.currentConfirmQuantity || 0), 0);
    },
    getCurrentDate () {
      const date = new Date();
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    getCurrentDateTime () {
      const date = new Date();
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hour = String(date.getHours()).padStart(2, '0');
      const minute = String(date.getMinutes()).padStart(2, '0');
      const second = String(date.getSeconds()).padStart(2, '0');
      return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
    },
    getCurrentUserName () {
      return (window.$core?.user?.userName) || '';
    },
    getAcceptanceRule (row) {
      return row.acceptanceRule || '-';
    },
    getRowKey (row) {
      return row.lineId;
    },
    formatAmount (value) {
      return Number(value || 0).toLocaleString('zh-CN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }
  }
};
</script>

<style lang="scss" scoped>
.pending-income-confirmation {
  padding-bottom: 20px;
}

:deep(.customer-po-code-input) {
  max-width: none;
}

.delivery-date-fields {
  display: inline-flex;
  align-items: center;
  flex-wrap: nowrap;
  white-space: nowrap;

  :deep(.el-date-editor.el-input) {
    width: 140px;
  }
}

.delivery-date-separator {
  flex: 0 0 auto;
  margin: 0 8px;
}

.top-action-bar {
  margin-bottom: 10px;
  text-align: right;
}

.empty-list {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 320px;
}

.order-card {
  margin-bottom: 10px;
  padding: 12px 14px 10px;
  background: #fff;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
}

.order-main {
  display: flex;
  align-items: center;
}

.order-info {
  min-width: 0;
  flex-shrink: 0;
  order: 1;
}

.order-title {
  display: flex;
  align-items: center;
  color: #303133;
  font-size: 16px;
  font-weight: 700;
}

.order-select-all {
  margin-right: 10px;
}

.order-meta {
  margin-top: 9px;
  color: #62748a;
  font-size: 13px;
}

.order-meta span {
  margin: 0 8px;
  color: #9aa9b8;
}

.order-stat-list {
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 0;
  margin-left: 14px;
  overflow-x: auto;
  order: 2;
}

.order-stat {
  flex: 1 1 170px;
  min-width: 170px;
  margin-left: 10px;
  padding: 12px;
  background: #f5f8fc;
  border-radius: 4px;
}

.order-stat:first-child {
  margin-left: 0;
}

.order-stat.two {
  flex: 0 0 120px;
  min-width: 120px;
}

.stat-label {
  color: #17233d;
  font-size: 14px;
}

.stat-value {
  margin-top: 6px;
  color: #17233d;
  font-size: 14px;
}

.order-actions {
  display: flex;
  align-items: center;
  margin-left: 14px;
  padding: 12px 0;
  flex-shrink: 0;
  order: 3;
}

.delivery-info {
  display: flex;
  align-items: center;
  margin-top: 12px;
  padding: 10px 12px;
  background: #f7f9fc;
  border: 1px solid #e7edf5;
  border-radius: 4px;
}

.delivery-info-fields {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  flex: 1;
  min-width: 0;
  row-gap: 8px;
}

.delivery-info-check {
  display: flex;
  align-items: center;
  flex: 0 0 30px;
}

.delivery-info-item {
  display: flex;
  align-items: center;
  flex: 0 1 200px;
  min-width: 0;
  min-height: 28px;
  padding-right: 16px;
  color: #303133;
  font-size: 13px;
}

.delivery-info-item--number {
  box-sizing: border-box;
  flex: 0 0 auto;
  max-width: 100%;
}

.delivery-info-item--address {
  flex: 1 1 300px;
}

.delivery-info-label {
  flex-shrink: 0;
  margin-right: 8px;
  color: #8795a5;
}

.delivery-info-value {
  min-width: 0;
  color: #17233d;
  font-weight: 600;
  overflow-wrap: anywhere;
}

.delivery-actions {
  display: flex;
  align-items: center;
  margin-left: 12px;
  flex-shrink: 0;
}

.line-table {
  margin-top: 12px;
}

.line-rule {
  display: inline-block;
  margin-top: 8px;
  padding: 2px 8px;
  color: #ff4d70;
  background: #fff0f3;
  border-radius: 12px;
  font-size: 12px;
}

.line-table ::v-deep .el-input-number {
  width: 88px;
}

.line-table ::v-deep .el-input__inner {
  text-align: left;
}

.pagination-wrap {
  margin-top: 10px;
  text-align: right;
}

.dialog-tip {
  margin-bottom: 16px;
  color: #62748a;
  line-height: 22px;
}

.acceptance-form ::v-deep .el-form-item__label {
  color: #303133;
  font-weight: 700;
  line-height: 20px;
}

.acceptance-form ::v-deep .el-date-editor.el-input {
  width: 210px;
}

.submit-acceptance-form {
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
}

.submit-acceptance-form ::v-deep .el-form-item {
  width: calc(33.333% - 16px);
  margin-right: 24px;
}

.submit-acceptance-form ::v-deep .el-form-item:nth-child(3n) {
  margin-right: 0;
}

.submit-acceptance-form ::v-deep .el-date-editor.el-input {
  width: 100%;
}

.submit-acceptance-form__attachments {
  width: calc(33.333% + 184px);
  margin-right: 0;
}

.submit-acceptance-form ::v-deep .el-form-item.submit-acceptance-form__attachments {
  width: calc(33.333% + 184px);
}

.readonly-date {
  display: inline-block;
  min-height: 32px;
  line-height: 32px;
  color: #303133;
}

.submit-table {
  margin-top: 10px;
}

.acceptance-dialog ::v-deep .el-dialog {
  border-radius: 8px;
}

.acceptance-dialog ::v-deep .el-dialog__body {
  padding-top: 10px;
}

.attachment-table {
  margin-top: 10px;
}

.attachment-name {
  color: #409eff;
  cursor: pointer;
}

.attachment-name:hover {
  text-decoration: underline;
}

.attachment-delete {
  color: #f56c6c;
  font-size: 16px;
}

@media screen and (max-width: 1659px) {
  .order-main {
    flex-wrap: wrap;
  }

  .order-info {
    display: flex;
    align-items: center;
    order: 1;
  }

  .order-meta {
    margin-top: 0;
    margin-left: 24px;
  }

  .order-actions {
    margin-left: auto;
    order: 2;
  }

  .order-stat-list {
    flex: 0 0 100%;
    margin-top: 12px;
    margin-left: 0;
    order: 3;
  }
}
</style>
